export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--O.3966725d.png";